export class QualityOfLifeIndexModel {

  public city: string;
  public state: string;
  public withRatingText: boolean;
  public familyof4_monthly_cost: any;
  public single_person_monthly_cost: any;
  public quality_of_life_index_rotate_one: number;
  public quality_of_life_index_rotate_two: number;
  public quality_of_life_index_rotate_three: number;
  public quality_of_life_index: any;
  public purchasing_power_incl_rent_index: any;
  public safety_index: any;
  public health_care_index: any;
  public climate_index: any;
  public cpi_index: any;
  public property_price_to_income_ratio: any;
  public traffic_time_index: any;
  public pollution_index: any;
	
  constructor(values?: Partial<QualityOfLifeIndexModel>) {
    Object.assign(this, values);

		this.city = "";
		this.state = "";
		this.withRatingText = false;

		this.purchasing_power_incl_rent_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.safety_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.health_care_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.climate_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.cpi_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.property_price_to_income_ratio = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.traffic_time_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
	
		this.pollution_index = {
			value: 0,
			rating: "",
			rating_color: ""
		}
  }
}
